
import { initialIdentifyState, IIdentifyState } from '../state/identify.state';
import { IdentifyActions, EIdentifyActions } from '../actions/identify.actions';

export const identifyReducers = (
    state = initialIdentifyState,
    action: IdentifyActions
): IIdentifyState => {
    switch (action.type) {
        case EIdentifyActions.GetIdentifySuccess: {
            return {
                ...state,
                identify: action.payload
            };
        }
        case EIdentifyActions.AddToken: {
            return {
                ...state,
                identify: {
                    ...state.identify,
                    token: action.payload
                }
            };
        }
        case EIdentifyActions.AddLanguage: {
            return {
                ...state,
                identify: {
                    ...state.identify,
                    language: action.payload
                }
            };
        }
        default:
            return state;
    }
};


